const baseUrl = process.env.REACT_APP_BASE_URL || 'https://localhost:44333/api/';

const WebsiteApiService = {
  // Method for handling the signup API call
  Add: async (data) => {
    try {
      const apiEndpoint = `${baseUrl}Website/Create`; // Complete URL for the endpoint

      const response = await fetch(apiEndpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        let errorMessage = "Error occurred";
        try {
          const errorData = await response.json();
          errorMessage = errorData.message || errorMessage;
        } catch (parseError) {
          console.error("Failed to parse error response", parseError);
        }
        throw new Error(errorMessage);
      }

      return await response.json(); // Return response data on success
    } catch (error) {
      console.error("Add Website error:", error);
      throw new Error("Network error or server unavailable");
    }
  },

  Get: async () => {
    try {
      const apiEndpoint = `${baseUrl}Website/Get`; // Complete URL for the test endpoint

      const response = await fetch(apiEndpoint, {
        method: 'GET', // Correctly capitalized method
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error occurred');
      }

      const result = await response.json(); // Parse the JSON response
      return result; // Return response data on success
    } catch (error) {
      console.error('Error:', error);
      throw new Error('Network error');
    }
  },

  GetAllWebByUserId: async (data) => {
    try {
      const apiEndpoint = `${baseUrl}Website/Get/${data}`; // Complete URL for the test endpoint

      const response = await fetch(apiEndpoint, {
        method: 'GET', // Correctly capitalized method
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error occurred');
      }

      const result = await response.json(); // Parse the JSON response
      return result; // Return response data on success
    } catch (error) {
      console.error('Error:', error);
      throw new Error('Network error');
    }
  },

  Update: async (data) => {
    try {
      const apiEndpoint = `${baseUrl}Website/Update`; // Complete URL for the signup endpoint

      const response = await fetch(apiEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data), // Convert data to JSON
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error occurred');
      }

      const result = await response.json(); // Parse the JSON response
      return result; // Return response data on success
    } catch (error) {
      console.error('Update Website error:', error);
      throw new Error('Network error');
    }
  },

  Delete: async (data) => {
    try {
      const apiEndpoint = `${baseUrl}Website/Delete/${data}`; // Correct URL with `/`

      const response = await fetch(apiEndpoint, {
        method: 'DELETE', // Use DELETE instead of POST
        headers: {
          'Content-Type': 'application/json',
        }
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error occurred');
      }

      const result = await response.json(); // Parse the JSON response
      return result; // Return response data on success
    } catch (error) {
      console.error('Delete Website error:', error);
      throw new Error('Network error');
    }
  },
  get: async (id) => {
    try {
      const apiEndpoint = `${baseUrl}Web/Get/${id}`;

      const response = await fetch(apiEndpoint, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error occurred');
      }

      const result = await response.json(); // Parse the JSON response
      return result; // Return response data on success
    } catch (error) {
      console.error('Error:', error);
      throw new Error('Network error');
    }
  },
  ChangeStatus: async (model) => {
    try {
      
      const apiEndpoint = `${baseUrl}Website/UpdateStatus`;
      const response = await fetch(apiEndpoint, {
        method: 'POST',
        body: model,
      });
  
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error occurred');
      }
  
      const result = await response.json();
      return result;
    } catch (error) {
      console.error('Error:', error);
      throw new Error('Network error');
    }
  },
  
  DownloadRejectionAttachment: async (id) => {
    window.location.href = `${baseUrl}Website/GetRejectionAttachment?id=${id}`;
  }
};

export default WebsiteApiService;
